import { config, msg } from 'api';
import { setErrorMessage } from 'apps/notifications/actions/notifications';
import { wa } from 'apps/analytics';
import { pageEvents } from 'apps/settings/analytics';
import { checkAvailableLoginMethods } from 'apps/login/actions/loginElevated';

export const SET_EMAIL = 'SET_EMAIL';
export const SET_CHANGE_EMAIL_VALIDATION_ERRORS = 'SET_CHANGE_EMAIL_VALIDATION_ERRORS';
export const SET_CHANGE_PASSWORD_VALIDATION_ERRORS = 'SET_CHANGE_PASSWORD_VALIDATION_ERRORS';

export function setEmail(email) {
  return {
    type: SET_EMAIL,
    email,
  };
}

export function setChangeEmailValidationErrors(errors) {
  return {
    type: SET_CHANGE_EMAIL_VALIDATION_ERRORS,
    errors,
  };
}

export function setChangePasswordValidationErrors(errors) {
  return {
    type: SET_CHANGE_PASSWORD_VALIDATION_ERRORS,
    errors,
  };
}

export function saveEmail(email, password, cb) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/email`,
      {
        body: JSON.stringify(
          { email, password },
        ),
      })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        wa.triggerPageEventWithDescription(pageEvents.CHANGE_CREDENTIALS_SAVE_EMAIL_SUCCESS_NOTIFICATION_DISPLAYED);
        dispatch(setChangeEmailValidationErrors({}));
        dispatch(setEmail(email));
        return true;
      })
      .catch((response) => {
        const responseCode = (response.data && response.data.code) || 'unknown error';
        wa.triggerPageEventWithDescription(
          pageEvents.CHANGE_CREDENTIALS_SAVE_EMAIL_ERROR_NOTIFICATION_DISPLAYED, { responseCode }
        );
        if (response.status === 412 && response.data) {
          dispatch(setChangeEmailValidationErrors(response.data));
          return false;
        }
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}

export function savePassword(password, currentPassword, cb) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/password`,
      {
        body: JSON.stringify({
          newPassword: password,
          currentPassword,
        }),
      })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        wa.triggerPageEventWithDescription(pageEvents.CHANGE_CREDENTIALS_SAVE_PASSWORD_SUCCESS_NOTIFICATION_DISPLAYED);
        dispatch(setChangePasswordValidationErrors({}));
        return dispatch(checkAvailableLoginMethods());
      })
      .catch((response) => {
        if (response.status === 412 && response.data) {
          dispatch(setChangePasswordValidationErrors(response.data));
          return false;
        }
        wa.triggerPageEventWithDescription(pageEvents.CHANGE_CREDENTIALS_SAVE_PASSWORD_ERROR_NOTIFICATION_DISPLAYED);
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}
